/* ReviewAndInstall.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "@media not all and (min-width:48rem){._1gde1bp4{flex-direction:column}._nssp1yb4{justify-content:space-between}._q5ugpxbi{margin-top:var(--ds-space-200,1pc)}}";
const _10 = "@media (min-width:48rem){._e8ghesu3{justify-content:flex-end}._15fl1ejb{margin-top:var(--ds-space-300,24px)}}";
const _9 = "._1nmznqa1 a{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _8 = "._yha28stv a{-webkit-text-decoration-line:underline;text-decoration-line:underline}";
const _7 = "._593818uv a{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _6 = "@media not all and (min-width:48rem){._1s6bukr8{margin:var(--ds-space-negative-400,-2pc)}}";
const _5 = "._ect418aq{font-family:var(--ds-font-family-brand-body,\"Charlie Text\",ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines-per-function */
import { media } from '@atlaskit/primitives';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { getParentEditionFromOfferings, useAppVersionListing } from '@atlassian/mpac-primitives';
import { AppDeployment } from '@atlassian/mpac-types';
import { InstallDialogEditionHeader as AppHeader } from '@atlassian/mpac-ui';
import { isSandboxInstance } from '@atlassian/mpac-utils';
import { List } from 'immutable';
import { useEffect } from 'react';
import { major } from 'semver';
import { checkIfGlobalLogsAndAnalyticsAreEnabled, findWebTriggerRule, getAppRoaStatus, getCategorizedEgressAndAnalytics } from '../../analyticsAndEgressUtil';
import { AnalyticsAndLogs } from '../../AnalyticsAndLogs/AnalyticsAndLogs';
import { AppEditionsSandboxSectionMessages } from '../../AppEditionsSandboxSectionMessages';
import { AppScopes } from '../../AppScopes';
import { DataEgress } from '../../DataManagement/DataEgress';
import { InstallableAppPrivacyInformation } from '../../InstallableAppPrivacyInformation';
import { MultiInstancePricingSectionMessage } from '../../MultiInstancePricingSectionMessage';
import { ScreenTitle } from '../../ScreenTitle';
import { SelectedEdition } from '../../SelectedEdition';
import { SelectedSiteDetails } from '../../SelectedSiteDetails';
import { SelectedUserCount } from '../../SelectedUserCount';
import { INSTALLATION_BLOCKING_APIS } from '../../useErrorAndLoadingStates';
import { useLatestVersionDetailsAndInstallationConfig } from '../../useLatestVersionDetailsAndInstallationConfig';
import { Pricing } from '../Pricing';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "@media (min-width:48rem){._19wgxy5q{gap:var(--ds-space-400,2pc)}}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const pricingContainerStyles = null;
const reviewAndInstallScreenStyles = null;
const linkOverrideStyles = null;
const ReviewAndInstallContent = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulp1ejb _1e0c1txw _2lx21bp4 _19wgxy5q", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ReviewAndInstallContent.displayName = 'ReviewAndInstallContent';
}
const environmentKey = 'production';

// eslint-disable-next-line max-lines-per-function, complexity
export const ReviewAndInstall = _ref2 => {
  var _hostStatusResponse$h;
  let {
    appHeaderDetails,
    links,
    appDetails,
    hostStatusResponse,
    installedAppDetailsResult,
    cmtAvailabilityResult,
    graphQLGatewayUrl,
    cloudId,
    updateErrAndLoadingState,
    selectedPlan,
    showAppPlans,
    enterprisePlanPurchased,
    appHasMultiInstanceEntitlement,
    eligibleOfferings,
    editionTypes,
    selectedUserSelection,
    userCount,
    selectedSiteUrl
  } = _ref2;
  const isForgeApp = appDetails.deploymentType === AppDeployment.ECOSYSTEM_CLOUD;
  const {
    latestVersionAppDetailsResult,
    latestVersionAppDetailsError,
    latestVersionAppDetailsLoading,
    globalInstallationConfigResult,
    globalInstallationConfigError,
    globalInstallationConfigLoading
  } = useLatestVersionDetailsAndInstallationConfig({
    appKey: isForgeApp ? appDetails.appIdentifier : '',
    environmentKey,
    cloudId,
    majorVersion: major(appDetails.version),
    skipGlobalInstallationConfig: !isForgeApp,
    skipLatestVersionAppDetails: !isForgeApp,
    gqlGatewayUrl: graphQLGatewayUrl
  });
  const {
    vendorLinks
  } = useAppVersionListing({
    appKey: appDetails.appKey,
    buildNumber: appDetails.buildNumber
  });
  useEffect(() => {
    const errorAndLoading = {
      error: !!globalInstallationConfigError,
      loading: !!globalInstallationConfigLoading
    };
    updateErrAndLoadingState(INSTALLATION_BLOCKING_APIS.INSTALLATION_CONFIG, errorAndLoading);
  }, [globalInstallationConfigError, globalInstallationConfigLoading, updateErrAndLoadingState]);
  useEffect(() => {
    const errorAndLoading = {
      error: !!latestVersionAppDetailsError,
      loading: !!latestVersionAppDetailsLoading
    };
    updateErrAndLoadingState(INSTALLATION_BLOCKING_APIS.LATEST_VERSION_DETAILS, errorAndLoading);
  }, [latestVersionAppDetailsError, latestVersionAppDetailsLoading, updateErrAndLoadingState]);
  const {
    enableLdCustomerGaChanges,
    enableAppificationChanges
  } = useStatsig();
  const roaStatus = getAppRoaStatus(latestVersionAppDetailsResult);
  const isGlobalLogsAndAnalyticsEnabled = checkIfGlobalLogsAndAnalyticsAreEnabled(globalInstallationConfigResult);
  const {
    categorizedRemoteEgress,
    analyticsEgress,
    inScopeEUDForLatestVersion
  } = getCategorizedEgressAndAnalytics(latestVersionAppDetailsResult);
  const hasWebTriggerEgress = findWebTriggerRule(latestVersionAppDetailsResult);
  const appScopesList = List(appDetails.appScopes.map(scope => appDetails.deploymentType === 'MarketplaceCloudAppDeployment' ? scope.capability : scope.id));
  const isSandbox = isSandboxInstance(hostStatusResponse === null || hostStatusResponse === void 0 ? void 0 : (_hostStatusResponse$h = hostStatusResponse.hostStatusResult) === null || _hostStatusResponse$h === void 0 ? void 0 : _hostStatusResponse$h.marketplaceStore.hostStatus.instanceType);
  const parentEdition = getParentEditionFromOfferings(eligibleOfferings);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8, _9]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_ect418aq _1s6bukr8", "_593818uv _yha28stv _1nmznqa1"]),
      children: [/*#__PURE__*/_jsx(ScreenTitle, {
        title: "Review and install",
        stepInfo: "Step 2 of 2"
      }), /*#__PURE__*/_jsxs(ReviewAndInstallContent, {
        children: [/*#__PURE__*/_jsx(AppHeader, {
          appHeaderDetails: _objectSpread(_objectSpread({}, appHeaderDetails), {}, {
            createdAt: undefined,
            // Since this data is unavailable in EMCEE, we are removing it from MPAC for consistency
            programs: _objectSpread(_objectSpread({}, appHeaderDetails.programs), {}, {
              runsOnAtlassian: undefined // Setting this to undefined to ensure data source (cs-apps) for RoA badge is consistent across MPAC and EMCEE
            })
          }),
          appIconLink: appDetails.appIconLink,
          appRatingLink: links.appRating,
          isAppCloudFortified: appDetails.isAppCloudFortified,
          bugBountyParticipant: appDetails.bugBountyParticipant,
          isRunsOnAtlassianApp: !!roaStatus,
          headerInjection: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_2, _10, _11]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_1e0c1txw _e8ghesu3 _15fl1ejb _1gde1bp4 _nssp1yb4 _q5ugpxbi"]),
              children: [enableLdCustomerGaChanges() && /*#__PURE__*/_jsx(SelectedSiteDetails, {
                selectedSiteUrl: selectedSiteUrl
              }), showAppPlans && selectedPlan && /*#__PURE__*/_jsx(SelectedEdition, {
                edition: selectedPlan.value,
                editionTypes: editionTypes,
                appPricingDetailsLink: links.appPricingDetails.expand({
                  appKey: appDetails.appKey
                })
              }), enableLdCustomerGaChanges() && selectedUserSelection === 'selectUsers' && /*#__PURE__*/_jsx(SelectedUserCount, {
                userCount: userCount
              }), /*#__PURE__*/_jsx(Pricing, {
                appDetails: appDetails,
                hostStatusResponse: hostStatusResponse,
                installedAppDetailsResult: installedAppDetailsResult,
                cmtAvailabilityResult: cmtAvailabilityResult,
                links: links,
                selectedPlan: selectedPlan,
                showAppPlans: showAppPlans,
                eligibleOfferings: eligibleOfferings,
                selectedUsersCount: userCount,
                areAllUsersSelected: selectedUserSelection === 'selectAllUsers'
              })]
            })]
          })
        }), isSandbox && !!parentEdition && showAppPlans && /*#__PURE__*/_jsx(AppEditionsSandboxSectionMessages, {
          eligibleOfferings: eligibleOfferings,
          selectedEditionTypeValue: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.value
        }), showAppPlans && selectedPlan && enterprisePlanPurchased && appHasMultiInstanceEntitlement && !isSandbox && /*#__PURE__*/_jsx(MultiInstancePricingSectionMessage, {
          eligibleOfferings: eligibleOfferings,
          enterprisePlan: enterprisePlanPurchased,
          selectedPlan: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.value,
          isStepReviewAndInstall: true
        }), /*#__PURE__*/_jsx(AppScopes, {
          graphQLGatewayUrl: graphQLGatewayUrl,
          appScopes: appScopesList,
          updateErrAndLoadingState: updateErrAndLoadingState
        }), /*#__PURE__*/_jsx(DataEgress, {
          egresses: categorizedRemoteEgress,
          queryError: latestVersionAppDetailsError,
          roaStatus: roaStatus,
          hasWebtriggerEgress: hasWebTriggerEgress,
          isForgeApp: isForgeApp,
          isLoading: latestVersionAppDetailsLoading,
          enableAppificationChanges: enableAppificationChanges()
        }), /*#__PURE__*/_jsx(AnalyticsAndLogs, {
          analyticsEgress: analyticsEgress,
          isGlobalLogsAndAnalyticsEnabled: isGlobalLogsAndAnalyticsEnabled,
          analyticsQueryError: latestVersionAppDetailsError,
          installConfigQueryError: globalInstallationConfigError,
          inScopeEUDForLatestVersion: inScopeEUDForLatestVersion,
          roaStatus: roaStatus,
          links: links,
          isForgeApp: isForgeApp,
          isLoading: latestVersionAppDetailsLoading,
          cloudId: cloudId
        }), /*#__PURE__*/_jsx(InstallableAppPrivacyInformation, {
          vendorLinks: vendorLinks,
          links: links,
          appName: appDetails.appName,
          appKey: appDetails.appKey,
          partner: appDetails.partner,
          privacyPolicyUrl: appDetails.privacyPolicyUrl,
          endUserLicenseAgreementUrl: appDetails.endUserLicenseAgreementUrl,
          appIdentifier: appDetails.appIdentifier,
          buildNumber: appDetails.buildNumber
        })]
      })]
    })]
  });
};